(function () {
  'use strict';
  function validate(action = {}) {
    let returnable;
    if (
      angular.isObject(action.display)
    ) {
      returnable = true;
    }
    return returnable;
  }
  function reducer({display: {metadata: {displayName, notes}, products}, vendorId}, $firedux) {
    let uid = $firedux.var('UID');
    return $firedux
      .ref('displays')
      .child(uid)
      .set({
        metadata: {
          vendorId,
          displayName,
          notes: notes || null
        },
        products: products || null
      })
      .then(() => $firedux
        .ref('vendors')
        .child(vendorId)
        .child('displays')
        .child(uid)
        .set(true))
      .then(() => uid);
  }
  angular
    .module('reducers')
    .run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'DISPLAY.ADD',
      reducer: function (action) {
        return validate(action) ?
          reducer(action, $firedux) :
          Promise.reject('VALIDATION ERROR');
      }
    });
  }
}());
